import { apiFetch } from "./apiClient";

export async function getDeviceCleaningConfigs(rcDeviceId) {
  const res = await apiFetch(
    `/api/services/cleaning/list-cleaning-configs/${rcDeviceId}`,
  );

  if (res.status === 404) {
    return [];
  }

  if (!res.ok) {
    throw new Error("Failed to fetch device cleaning configs");
  }

  return res.json();
}

export async function getDeviceAvailableConfigs(rcDeviceId) {
  const res = await apiFetch(
    `/api/services/cleaning/available-config-names/${rcDeviceId}`,
  );

  if (res.status === 404) {
    return [];
  }

  if (!res.ok) {
    throw new Error("Failed to fetch device available cleaning configs");
  }

  return res.json();
}

export async function createOrUpdateCleaningConfigs(cleaningConfigData) {
  const res = await apiFetch(`/api/services/cleaning/set-cleaning-configs`, {
    method: "POST",
    body: JSON.stringify(cleaningConfigData),
  });
  if (!res.ok) {
    throw new Error("Failed to create or update cleaning configs");
  }
  const data = await res.json();
  return { success: true, data };
}
